export default "__VITE_ASSET__ce5879e4__"